


































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { RateSourceModule } from '@/store/Products/RateSourceModule';
import RateSourceEdit from '@/components/Products/RateSources/RateSourceEdit.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'RateSourceDetails', components: { RateSourceEdit } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    get rateSource() {
        return RateSourceModule.rateSource;
    }
}
